import {Vec2} from "../lib/points";

export class MathHelper {
  /**
   *
   * @param {Vec2} a
   * @param {Vec2} b
   * @param {Vec2} c
   * @param {Vec2} d
   * @param {number} u
   * @param {number} v
   * @return {Vec2}
   */
  static quadInterp(a, b, c, d, u, v) {
    const x = (1-u)*(1-v)*a.x + u*(1-v)*b.x + u*v*c.x + (1-u)*v*d.x;
    const y = (1-u)*(1-v)*a.y + u*(1-v)*b.y + u*v*c.y + (1-u)*v*d.y;

    return new Vec2(x, y);
  }

  /**
   *
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   * @return {Vec2}
   */
  static pxToGL(x, y, width, height) {
    return new Vec2(
      (x / width) * 2 - 1,
      1 - (y / height) * 2
    );
  }

  /**
   *
   * @param {Vec2} v
   * @param {number} width
   * @param {number} height
   * @return {Vec2}
   */
  static glToPx(v, width, height) {
    return new Vec2(
      ((v.x + 1) * 0.5) * width,
      (1 - (v.y + 1) * 0.5) * height
    );
  }

  /**
   *
   * @param {number} p0
   * @param {number} p1
   * @param {number} p2
   * @param {number} p3
   * @param {number} t
   * @return {number}
   */
  static bez (p0, p1, p2, p3, t)  {
    return ((1 - t) ** 3) * p0 +
      3 * ((1 - t) ** 2) * t * p1 +
      3 * (1 - t) * (t ** 2) * p2 +
      (t ** 3) * p3;
  }

  /**
   *
   * @param {Vec2} a
   * @param {Vec2} b
   * @param {Vec2} c
   * @param {Vec2} d
   * @param {number} t
   * @return {Vec2}
   */
  static bezV (a, b, c, d, t) {
    const x = this.bez(a.x, b.x, c.x, d.x, t);
    const y = this.bez(a.y, b.y, c.y, d.y, t);

    return new Vec2(x, y);
  };
}
